export const FILES_STATUSES = {
  ACTIVE: 'ACTIVE',
  HIDDEN: 'HIDDEN',
  ARCHIVED: 'ARCHIVED',
} as const;

export type FilesStatus = (typeof FILES_STATUSES)[keyof typeof FILES_STATUSES];
